import { render, staticRenderFns } from "./PackDuration.vue?vue&type=template&id=76a571a2&"
import script from "./PackDuration.vue?vue&type=script&lang=ts&"
export * from "./PackDuration.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports